import { useSortable } from "@dnd-kit/sortable";
import { useContext } from "react";

import { dragActiveStyle } from "./constants";
import { DragIndexContext } from "./context";
import { HeaderCellProps } from "./type";

export const HorizontalTableHeaderCell: React.FC<HeaderCellProps> = (props) => {
    const dragState = useContext(DragIndexContext);
    const { attributes, listeners, setNodeRef, isDragging } = useSortable({ id: props.id });
    const style: React.CSSProperties = {
        ...props.style,
        cursor: "move",
        ...(isDragging ? { position: "relative", zIndex: 999, userSelect: "none" } : {}),
        ...dragActiveStyle(dragState, props.id),
    };
    return <th {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
};

export const VerticalTableHeaderCell: React.FC<HeaderCellProps> = (props) => {
    return <th {...props} style={props.style} />;
};
